import { render, staticRenderFns } from "./new_user_import.vue?vue&type=template&id=0d2feefb&"
import script from "./new_user_import.vue?vue&type=script&lang=js&"
export * from "./new_user_import.vue?vue&type=script&lang=js&"
import style0 from "./new_user_import.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports